import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { fixImageUrl } from "../utils/fixImageUrl.js";

export default function ArtistCard({ artist, variant, isAr: isArProp }) {
  const { t, i18n } = useTranslation();
  const [imgErr, setImgErr] = useState(false);

  const isAr      = isArProp ?? (i18n.language === "ar" || i18n.language?.startsWith("ar"));
  const isElder   = variant === "elder";

  const name      = isAr ? (artist?.name_ar      || artist?.name)     : (artist?.name     || "");
  const specialty = isAr ? (artist?.specialty_ar  || artist?.specialty): (artist?.specialty || "");
  const intro     = isAr ? (artist?.intro_ar      || artist?.intro)    : (artist?.intro    || "");

  const imgSrc    = fixImageUrl(artist?.photo_url || artist?.profileImage);
  const initial   = (artist?.name || "").trim()[0]?.toUpperCase() || "?";
  const profileUrl = `/ArtistProfile/${artist.id || artist._id}`;

  return (
    <article className="ac-root">
      <a href={profileUrl} className="ac-img-wrap" tabIndex={-1} aria-hidden="true">
        {imgSrc && !imgErr ? (
          <img
            src={imgSrc}
            alt={name}
            className="ac-img"
            onError={() => setImgErr(true)}
          />
        ) : (
          <div className="ac-img ac-img-placeholder" aria-hidden="true">
            <span>{initial}</span>
          </div>
        )}

        <div className="ac-overlay">
          <span className="ac-overlay-cta">{t("artists.portfolio")}</span>
        </div>

        <div className="ac-badges">
          {isElder && (
            <span className="ac-badge ac-badge-gold">
              ★ {t("artists.goldenMember")}
            </span>
          )}
          {artist?.country && (
            <span className="ac-badge ac-badge-country">{artist.country}</span>
          )}
        </div>
      </a>

      <div className="ac-body">
        <h3 className="ac-name">
          <a href={profileUrl}>{name}</a>
        </h3>
        {specialty && (
          <p className="ac-specialty">{specialty}</p>
        )}
        {intro && (
          <p className="ac-intro">
            {intro.length > 110 ? `${intro.slice(0, 110)}…` : intro}
          </p>
        )}
        <a href={profileUrl} className="ac-cta">
          {t("artists.portfolio")}
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </a>
      </div>
    </article>
  );
}
